import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _typeof from "@babel/runtime/helpers/typeof";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { GraphqlQueryName, NavigationDataType } from './types';
var attributesMapper;
/**
 * getKeyName returns the id of the component of which the data belongs to
 * @param key  object keys of one-graph query response. Its value will be eithr digitalPlatformHeader or digitalPlatformFooter
 * @param navigationDataType  id for which the data is fetched.
 * @returns { string }  Returns the id of the component of which the data belongs to.
 *
 * @example ```
 * Input: key ='digitalPlatformFooter', navigationDataType = 'SignedOutHeader,FooterLegal'
 * Result: 'FooterLegal'
 * ```
 */

(function (attributesMapper) {
  attributesMapper["primaryNav"] = "PrimaryNav";
  attributesMapper["secondaryNav"] = "SecondaryNav";
  attributesMapper["userNav"] = "UserNav";
  attributesMapper["legalNav"] = "LegalNav";
  attributesMapper["languageSelector"] = "LanguageSelector";
  attributesMapper["languageSelectorChildren"] = "children";
  attributesMapper["languageSelectorConfiguration"] = "configuration";
  attributesMapper["navType"] = "type";
  attributesMapper["footerLegalNote"] = "FooterLegalNote";
  attributesMapper["navText"] = "text";
  attributesMapper["navUrl"] = "href";
  attributesMapper["digitalPlatformHeader"] = "navigationMenu";
  attributesMapper["digitalPlatformFooter"] = "navigationMenu";
  attributesMapper["digitalPlatformLanguageSelector"] = "navigationMenu";
  attributesMapper["externalApi"] = "API";
  attributesMapper["navIconUrl"] = "ICON";
  attributesMapper["iconPosition"] = "position";
})(attributesMapper || (attributesMapper = {}));

export var getKeyName = function getKeyName(key, navigationDataType) {
  if (key === GraphqlQueryName.digitalPlatformHeader) return NavigationDataType.SignedOutHeader;

  if (key === GraphqlQueryName.digitalPlatformFooter) {
    if (navigationDataType.includes(NavigationDataType.SignedOutFooter)) return NavigationDataType.SignedOutFooter;else if (navigationDataType.includes(NavigationDataType.SignedInFooter)) return NavigationDataType.SignedInFooter;else return NavigationDataType.FooterLegal;
  }

  return '';
};
/**
 * isValidContent return false if one of the PrimaryNav, SecondaryNav, LegalNav or FooterLegalNote is Null
 * @param result formated graphql query response
 * @returns { boolean } returns true if the input is has ValidContent if not then returns false
 *
 * @example ```
 * Input: result = { PrimaryNav: null, SecondaryNav: []}
 * Result: false
 * ```
 */

export var isValidContent = function isValidContent(result) {
  for (var _i = 0, _Object$keys = Object.keys(result); _i < _Object$keys.length; _i++) {
    var childKey = _Object$keys[_i];
    if (result[childKey] === null && [attributesMapper.primaryNav, attributesMapper.secondaryNav, attributesMapper.legalNav, attributesMapper.footerLegalNote].includes(childKey)) return false;
  }

  return true;
};
export var formatOneGraphData = function formatOneGraphData(data) {
  return formatDPQueryData(data);
};
export var formatDPQueryData = function formatDPQueryData(data) {
  var result = {};

  if (data && _typeof(data) === 'object') {
    // If data is object, we need to check for nestedKeys
    if (Array.isArray(data)) {
      // If object is an array, we need to check for all array elements
      var navMenuItems = [];

      var _iterator = _createForOfIteratorHelper(data),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var navMenuItem = _step.value;
          navMenuItems.push(formatDPQueryData(navMenuItem)); // Checking for each array item
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return navMenuItems;
    } else {
      Object.entries(data).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            value = _ref2[1];

        //If it not array, checking for attributes values.
        if (key in attributesMapper) {
          result = _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, attributesMapper[key], formatDPQueryData(value)));
        } else {
          result = _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, key, formatDPQueryData(value)));
        }
      });
    }
  } else {
    return data; // If its a primitive data, return the data
  }

  return result;
};